import { SvgIcon } from "@mui/material";
import { ReactComponent as VisibilityOnIcon } from "../icons/ic_visibility_on.svg";

function VisibilityOn(props) {
  return <SvgIcon {...props} component={VisibilityOnIcon} inheritViewBox />;
}

export default VisibilityOn;
